<template>
    <div class="podcast">
        <admin-layout v-if="isBackend"
                      class="admin-layout"
                      :show-navbar="true"
                      :show-sidebar="true">
            <app-content-pane class="ml-3">
                <podcast-player class="podcast-player"
                                :show-close="showClose"
                                :podcast="podcast"/>
            </app-content-pane>
        </admin-layout>
        <public-layout v-else
                       :headless="headless"
                       class="public-layout">
            <podcast-player class="podcast-player"
                            :show-close="showClose"
                            :podcast="podcast"
                            :hideSidebar="hideSidebar"/>
        </public-layout>

    </div>
</template>

<script>
import PodcastPlayer from "@/Components/Podcast2/PodcastPlayer";
import PublicLayout from "@/Layouts/PublicLayout";
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
export default {
    name: "Show",

    components: {
        AppContentPane,
        AdminLayout,
        PublicLayout,
        PodcastPlayer
    },

    props: {
        podcast: {
            type: Object,
        },
        isBackend: {
            type: Boolean,
            default: false,
        },
        showClose: {
            type: Boolean,
            default: false,
        },
        headless: {
            type: Boolean,
            default: false,
        },
        hideSidebar: {
            type: Boolean,
            default: false
        }
    },



    mounted() {
        this.setTitle( 'Podcast' );
    }

}
</script>

<style lang="scss" scoped>
.podcast-player{
    //margin-top: -17px;
    border-top-left-radius: .5rem;
    overflow: hidden;
}
</style>
